import { render } from "./ShopSVG.vue?vue&type=template&id=4e1e0b28"
import script from "./ShopSVG.vue?vue&type=script&lang=js"
export * from "./ShopSVG.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__